import { useCallback } from 'react';
import { formatDateTimeWithLocale } from 'utils/date';

export const useDateTimeFormatter = (language: string, atText: string): ((dateString: string) => string) => {
  return useCallback(
    (dateString: string): string => {
      return formatDateTimeWithLocale(dateString, language).replace(',', ` ${atText}`);
    },
    [language, atText],
  );
};
